import { Component, Input, OnInit } from '@angular/core';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';

import { Observable } from 'rxjs';

import { Mention } from '../../../Mentions/models/mention';

import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';

import { FullProfileAnimationModel } from '../../../../Core/Dialogs/models/full-profile-animation.model';

import { MentionsService } from '../../../../Monitor/Core/services/mentions.service';
import { MediaTypeEnum } from '../../../Basic/enums/media-type.enum';

@Component({
    selector: 'agpr-post-viewer-dialog',
    templateUrl: './post-viewer-dialog.component.html',
    styleUrls: ['./post-viewer-dialog.component.scss'],
    standalone: false
})

export class PostViewerDialogComponent extends AbstractDialogComponent implements OnInit {

    @Input() id: string = 'postViewer';
    @Input() set mention(mention: Mention) {
        this._mention = mention;
        if (this._mention.mediaType.id === MediaTypeEnum.FACEBOOK
            || this._mention.mediaType.id === MediaTypeEnum.INSTAGRAM) {
            this.minPanelWidth = 955;
            this.maxPanelWidth = 955;
        }
    };
    @Input() overlayContainer: Element;
    @Input() animationTrigger: Observable<FullProfileAnimationModel>;
    _mention: Mention;

    minPanelWidth = 1124;
    maxPanelWidth = 1240;
    hideSlideOverlay = false;

    readonly mediaTypes = MediaTypeEnum;
    readonly buttonTypesEnum = ButtonTypesEnum;

    constructor(
        public coreDialogService: CoreDialogService,
        private mentionService: MentionsService,
    ) {
        super(coreDialogService, 'PostViewer');
    }

    ngOnInit() {
        this.mentionService.setFocusedMention(this._mention);
    }

    close(overlayVisibility?: boolean): void {
        if (!overlayVisibility) {
            this.closeDialog();
        }
    }
}
